export default __webpack_public_path__ + "static/media/logo192.0e35cbd1.png";